import { Form, Input } from 'antd';
import classNames from 'classnames';

import { TextAreaTplType } from '../types/tplTypes';
const { TextArea } = Input;
export const TextAreaTpl = ({ data }: { data: TextAreaTplType }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return (
    <Form.Item
      className={classNames({
        'bybit-form-item__extra': !!data.formItemProps?.extra,
      })}
      name={data.id}
      label={data.label}
      {...(data.formItemProps || {})}
    >
      <TextArea
        placeholder={data?.placeholder}
        {...(data.componentProps || {})}
      />
    </Form.Item>
  );
};
